export default "__VITE_ASSET__2a46b149__"